import { IMapControlParam } from '@/types/map'

import { loadModules } from "esri-loader";

//arcgis二维地图缩放控件
export class ZoomArc2D {
    private static instances: Map<string, any>;//一个BMap.Map对应一个Control
    private view!: __esri.MapView | __esri.SceneView;
    private control: any;//缩放控件
    private visible: boolean;
    private anchor: string;//"top-left"\"top-right"\"bottom-left"\"bottom-right"
    private layout: string;//控件方向："vertical","horizontal"

    constructor(view: any, option?: any) {
        this.view = view;
        this.visible = false;
        this.anchor = "top-left";
        this.layout = "vertical";
    }

    private async initiate() {
        const [Zoom] = await loadModules([
            "esri/widgets/Zoom"
        ]);
        //为地图添加一个缩放控件
        this.control = new Zoom({
            visible: this.visible,
            view: this.view,
            layout: this.layout
        });
        this.view.ui.add(this.control, this.anchor);
    }

    public static getInstance(view: any, options?: any): ZoomArc2D {
        let id = view.container.id;
        if (!ZoomArc2D.instances) {
            ZoomArc2D.instances = new Map();
        }
        let instance = ZoomArc2D.instances.get(id);
        //若没有view对应的实例，则重新创建一个
        if (!instance) {
            instance = new ZoomArc2D(view, options);
            ZoomArc2D.instances.set(id, instance);
        }
        return instance;
    }

    public async set(params: IMapControlParam) {
        if (!this.view) {
            //地图未创建，直接返回
            return;
        }
        if (!this.control) {
            await this.initiate();
        }
        this.visible = params.visible || false;
        this._setVisible();
        this.anchor = params.anchor || "top-left";
        this._setAnchor();
        if (params.options?.layout) {
            this.layout = params.options?.layout;
            this._setLayout();
        }
    }

    //设置锚点
    private async _setAnchor() {
        let ca: string;
        switch (this.anchor) {
            case "bottom-left":
                this.view.ui.move(this.control, "bottom-left");
                break;
            case "top-right":
                this.view.ui.move(this.control, "top-right");
                break;
            case "bottom-right":
                this.view.ui.move(this.control, "bottom-right");
                break;
            case "top-left":
            default:
                this.view.ui.move(this.control, "top-left");
                break;
        }
    }
    
    //设置是否可见
    private async _setVisible() {
        if (this.visible) {
            this.control.visible = this.visible;
        } else {
            this.control.visible = false;
        }
    }

    //设置方向
    private async _setLayout() {
        this.control.layout = this.layout;
    }
};